import React from 'react';
import { connect } from 'react-redux';
import { branch, compose, renderNothing, renderComponent } from 'react-recompose';
//////////////////////////////////////////////////

const mapStateToProps = (state) => ({
  loggedIn: state.auth.loggedIn,
});

const userAuthHoc = (WrappedComponent) => {
  const enhance = compose(
    branch(
      (props) => props.loggedIn,
      renderComponent(WrappedComponent),
      renderNothing,
  ));
  return connect(mapStateToProps)(enhance(WrappedComponent));
};

export default userAuthHoc;
